/* Lahja miehelle – yhteinen JavaScript. Tiedosto voidaan ladata useaan kertaan; määrittelyt tehdään vain kerran. */
(function () {
  if (window.__gftLoaded) return;
  window.__gftLoaded = true;
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Vaihtuva sana otsikossa */
  if (!customElements.get('gft-rotator')) {
    customElements.define('gft-rotator', class extends HTMLElement {
      connectedCallback() {
        var words = (this.dataset.words || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
        if (words.length < 2 || RM) return;
        var i = 0, el = this, ms = parseInt(this.dataset.interval, 10) || 2600;
        /* Sanan leveys mitataan etukäteen, ja tila muuttuu liukuen, jotta loppuosa otsikosta ei hypi. */
        var measure = function (txt) {
          var m = document.createElement('span');
          m.className = 'gft-rot';
          m.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap;width:auto;transition:none';
          m.textContent = txt;
          el.parentNode.appendChild(m);
          var w = m.getBoundingClientRect().width;
          m.remove();
          return w;
        };
        /* Vaihtuva sana ja otsikon loppu omalle rivilleen, jotta pitkä sana ei siirrä rivinvaihtoa kesken kierron. */
        if (!(el.previousSibling && el.previousSibling.nodeName === 'BR')) el.parentNode.insertBefore(document.createElement('br'), el);
        el.style.whiteSpace = 'nowrap';
        el.style.transition = 'opacity .45s, transform .45s, width .45s cubic-bezier(.2,.7,.2,1)';
        this._r = function () { el.style.width = ''; };
        window.addEventListener('resize', this._r);
        this._t = setInterval(function () {
          var next = words[(i + 1) % words.length];
          el.style.width = el.getBoundingClientRect().width + 'px';
          el.classList.add('is-out');
          setTimeout(function () {
            i = (i + 1) % words.length;
            el.style.width = measure(next) + 'px';
            el.textContent = next;
            el.classList.remove('is-out');
          }, 450);
        }, ms);
      }
      disconnectedCallback() { clearInterval(this._t); if (this._r) window.removeEventListener('resize', this._r); }
    });
  }

  /* Karuselli: yksi kortti kerrallaan, päättymätön kierto kloonien avulla */
  if (!customElements.get('gft-carousel')) {
    customElements.define('gft-carousel', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.track = this.querySelector('.gft-track');
        if (!this.track) return;
        this.pos = 1; this.busy = false;
        this.build();
        this.track.addEventListener('transitionend', function () { self.fix(); });
        var prev = this.querySelector('.gft-arr--prev'), next = this.querySelector('.gft-arr--next');
        if (prev) prev.addEventListener('click', function () { self.step(-1); });
        if (next) next.addEventListener('click', function () { self.step(1); });
        this.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') self.step(-1); if (e.key === 'ArrowRight') self.step(1); });
        var x0 = null, dx = 0, w = 1;
        this.addEventListener('pointerdown', function (e) { if (e.target.closest('button,a')) return; x0 = e.clientX; dx = 0; w = self.offsetWidth; self.track.style.transition = 'none'; });
        this.addEventListener('pointermove', function (e) { if (x0 === null) return; dx = e.clientX - x0; self.track.style.transform = 'translateX(calc(' + (-self.pos * 100) + '% + ' + dx + 'px))'; });
        var end = function () { if (x0 === null) return; x0 = null; if (Math.abs(dx) > w * 0.18) self.step(dx < 0 ? 1 : -1); else self.go(true); };
        this.addEventListener('pointerup', end); this.addEventListener('pointercancel', end); this.addEventListener('pointerleave', end);
        if (window.Shopify && Shopify.designMode) {
          document.addEventListener('shopify:block:select', function (e) {
            var items = self.items();
            for (var i = 0; i < items.length; i++) if (items[i].contains(e.target) || items[i] === e.target) { self.pos = i + 1; self.go(false); }
          });
        }
      }
      items() { return [].slice.call(this.track.children).filter(function (x) { return x.nodeType === 1 && !x.classList.contains('gft-clone'); }); }
      build() {
        this.track.querySelectorAll('.gft-clone').forEach(function (x) { x.remove(); });
        var items = this.items(); this.n = items.length;
        this.setAttribute('data-count', this.n);
        if (this.n < 2) { this.pos = 0; this.go(false); return; }
        var f = items[0].cloneNode(true), l = items[this.n - 1].cloneNode(true);
        [f, l].forEach(function (c) { c.classList.add('gft-clone'); c.setAttribute('aria-hidden', 'true'); c.removeAttribute('data-shopify-editor-block'); c.querySelectorAll('a,button').forEach(function (a) { a.tabIndex = -1; }); });
        this.track.appendChild(f); this.track.insertBefore(l, this.track.firstChild);
        this.pos = 1; this.go(false);
      }
      go(anim) { this.track.style.transition = (anim && !RM) ? 'transform .45s cubic-bezier(.2,.7,.2,1)' : 'none'; this.track.style.transform = 'translateX(' + (-this.pos * 100) + '%)'; }
      step(d) { if (this.busy || this.n < 2) return; this.busy = true; this.pos += d; this.go(true); if (RM) this.fix(); }
      fix() { this.busy = false; if (this.pos === 0) { this.pos = this.n; this.go(false); } else if (this.pos === this.n + 1) { this.pos = 1; this.go(false); } }
    });
  }

  /* Kokolaskuri */
  if (!customElements.get('gft-size-calc')) {
    customElements.define('gft-size-calc', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        var cfg = {};
        try { cfg = JSON.parse(this.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
        this.cfg = cfg; this.body = 'none';
        this.models = this.parse(cfg.chart || '');
        this.shirt = this.parse(cfg.shirt || '')[0] || null;
        ['w', 't', 'c'].forEach(function (k) { var i = self.querySelector('[data-f="' + k + '"]'); if (i) i.addEventListener('input', function () { self.calc(); }); });
        var chips = this.querySelector('.gft-chips');
        if (chips) chips.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          chips.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true'); self.body = b.dataset.b; self.calc();
        });
        this.calc();
      }
      /* Rivi: [adv] Malli | huomautus | S=75-83/58; M=84-92/62  (vyötärö haarukka / reisi enintään) */
      parse(text) {
        return text.split(/\n/).map(function (line) {
          line = line.trim(); if (!line) return null;
          var adv = /^\[adv\]/i.test(line); line = line.replace(/^\[adv\]\s*/i, '');
          var parts = line.split('|').map(function (s) { return s.trim(); });
          if (parts.length < 2) return null;
          var sizes = parts[parts.length - 1];
          if (sizes.indexOf('=') < 0) return null;
          var r = [];
          sizes.split(';').forEach(function (seg) {
            var m = seg.trim().match(/^([^=]+)=\s*(\d+)\s*-\s*(\d+)(?:\s*\/\s*(\d+)\s*)?$/);
            if (m) r.push({ k: m[1].trim(), lo: +m[2], hi: +m[3], t: m[4] ? +m[4] : 0 });
          });
          return { name: parts[0], note: parts.length > 2 ? parts[1] : '', adv: adv, r: r, hasT: r.some(function (x) { return x.t; }) };
        }).filter(Boolean);
      }
      /* Vyötärö valitsee koon; jos reisi ylittää koon rajan, nostetaan ensimmäiseen kokoon, johon reisi mahtuu */
      pick(r, w, t) {
        var bi = -1, bs = 1e9;
        r.forEach(function (x, i) { var d = w < x.lo ? x.lo - w : (w > x.hi ? w - x.hi : 0); if (d < bs) { bs = d; bi = i; } });
        if (bi < 0) return { size: null };
        var res = { size: r[bi].k, edge: bs > 0, up: false };
        if (t && r[bi].t && t > r[bi].t) {
          for (var j = bi + 1; j < r.length; j++) if (r[j].t && t <= r[j].t) { res.size = r[j].k; res.up = true; return res; }
          res.size = r[r.length - 1].k; res.up = true; res.edge = true;
        }
        return res;
      }
      esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
      row(m, r) {
        var c = this.cfg, mut = function (t) { return ' <span style="font-weight:400;color:var(--gft-muted)">(' + t + ')</span>'; }, notes = [];
        if (r.edge) notes.push(this.esc(c.edge || ''));
        if (r.up) notes.push(this.esc(c.thighUp || ''));
        if (!m.hasT && m.tAsked && c.noThigh) notes.push(this.esc(c.noThigh));
        return '<tr><td>' + this.esc(m.name) + (notes.length ? mut(notes.filter(Boolean).join(', ')) : '') + (m.note ? '<span class="gft-note">' + this.esc(m.note) + '</span>' : '') + '</td><td>' + this.esc(r.size || '–') + '</td></tr>';
      }
      calc() {
        var c = this.cfg, o = this.querySelector('.gft-out'); if (!o) return;
        var val = function (k, el) { el = el.querySelector('[data-f="' + k + '"]'); return el ? +el.value : 0; };
        var w = val('w', this), t = val('t', this), ch = val('c', this);
        if (!w && !ch) { o.textContent = c.empty || ''; return; }
        var html = '<table>', self = this;
        if (w) this.models.forEach(function (m) {
          if (m.adv && !c.advOn) { html += '<tr><td>' + self.esc(m.name) + '<span class="gft-note">' + self.esc(c.soon || '') + '</span></td><td>–</td></tr>'; return; }
          m.tAsked = !!t;
          html += self.row(m, self.pick(m.r, w, t));
        });
        if (ch && this.shirt) html += this.row(this.shirt, this.pick(this.shirt.r, ch, 0));
        html += '</table>';
        var tip = (c.tips || {})[this.body];
        if (tip) html += '<div class="gft-tip">' + this.esc(tip) + '</div>';
        o.innerHTML = html;
      }
    });
  }

  /* Lahjakortin summa */
  if (!customElements.get('gft-giftcard')) {
    customElements.define('gft-giftcard', class extends HTMLElement {
      connectedCallback() {
        var self = this, box = this.querySelector('.gft-amts'), amt = this.querySelector('.gft-gcard__amt'), btn = this.querySelector('[data-gc-buy]');
        if (!box) return;
        box.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          box.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          if (amt) amt.textContent = b.dataset.label;
          if (btn && b.dataset.url) btn.setAttribute('href', b.dataset.url);
        });
      }
    });
  }

  /* Päiviä jäljellä -palkki */
  if (!customElements.get('gft-countdown')) {
    customElements.define('gft-countdown', class extends HTMLElement {
      connectedCallback() {
        var t = this.querySelector('[data-text]'); if (!t) return;
        var d = new Date(this.dataset.date + 'T00:00:00');
        var days = Math.ceil((d - new Date()) / 864e5);
        t.textContent = (!isNaN(days) && days > 0) ? (this.dataset.template || '').replace('{days}', days) : (this.dataset.after || '');
      }
    });
  }
})();
